import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { NavLink } from 'ion-navchevron'
import logo from '../../static/general/house-and-garden.svg'
import logoM from '../../static/general/house-and-garden-white.svg'
import logoMH from '../../static/general/h-white.svg'
import { Button } from 'semantic-ui-react'
import { MenuIco } from 'ion-icon'
import { defaultWidth, Mobile, DesktopTablet } from 'ion-media'
import useHasMounted from '../../../lib/useHasMounted'

const Header = (props) => {
  const hasMounted = useHasMounted()
  return (
    <header role='banner' className={props.useSmall ? 'reduced-header' : ''}>
      <a href='#main-content' className='show-on-focus' tabIndex='0'>
        Skip to content
      </a>
      <div className='wrapper'>
        <Mobile values={{ deviceWidth: defaultWidth }}>
          <Button tabIndex='2' className='menu-btn' onClick={props.handleToggleMenu}><MenuIco width='24' height='24' /></Button>
        </Mobile>
        <Link to='/' className='logo'>
          <Mobile values={{ deviceWidth: defaultWidth }}>
            <img src={logoM} className='logo-mob' alt='Cond&eacute; Nast House &amp; Garden' />
            <img src={logoMH} className='logo-mob-h' alt='Cond&eacute; Nast House &amp; Garden' />
          </Mobile>
          {hasMounted &&
            <DesktopTablet values={{ deviceWidth: defaultWidth }}>
              <img src={logo} alt='Cond&eacute; Nast House &amp; Garden' />
            </DesktopTablet>}
        </Link>
      </div>
      <DesktopTablet values={{ deviceWidth: defaultWidth }}>
        <div className='wrapper'>
          <nav>
            <ul>
              <li>
                <NavLink to='/design'>Design</NavLink>
                <ul className='menu-articles'>
                  <li>
                    <Link to='/design/trends'>Trends</Link>
                  </li>
                  <li>
                    <Link to='/design/art'>Art</Link>
                  </li>
                  <li>
                    <Link to='/design/architecture'>Architecture</Link>
                  </li>
                  <li>
                    <Link to='/design/innovative'>Innovative Designs</Link>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to='/doty-awards'>DOTY Awards</NavLink>
                <ul className='menu-articles'>
                  <li>
                    <Link to='/doty-awards'>DOTY Awards</Link>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to='/interiors'>Interiors</NavLink>
                <ul className='menu-articles'>
                  <li>
                    <Link to='/interiors/bathroom'>Bathroom</Link>
                  </li>
                  <li>
                    <Link to='/interiors/bedroom'>Bedroom</Link>
                  </li>
                  <li>
                    <Link to='/interiors/kitchen'>Kitchen</Link>
                  </li>
                  <li>
                    <Link to='/interiors/living-room'>Living Room</Link>
                  </li>
                  <li>
                    <Link to='/interiors/house-tours'>House Tours</Link>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to='/gardens'>Gardens</NavLink>
                <ul className='menu-articles'>
                  <li>
                    <Link to='/gardens'>Gardens</Link>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to='/travel-leisure'>Travel &amp; Leisure</NavLink>
                <ul className='menu-articles'>
                  <li>
                    <Link to='/travel-leisure'>Travel &amp; Leisure</Link>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to='/recipes'>Recipes</NavLink>
                <ul className='menu-articles'>
                  <li>
                    <Link to='/recipes'>Recipes</Link>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to='/diy'>DIY</NavLink>
                <ul className='menu-articles'>
                  <li>
                    <Link to='/diy'>DIY</Link>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to='/video'>Video</NavLink>
                <ul className='menu-articles'>
                  <li>
                    <Link to='/video'>Video</Link>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to='/shopping'>Shopping</NavLink>
                <ul className='menu-articles'>
                  <li>
                    <Link to='/shopping'>Shopping</Link>
                  </li>
                  <li>
                    <Link to='/shopping/gift-guide'>Gift Guide</Link>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to='/win'>Win</NavLink>
                <ul className='menu-articles'>
                  <li>
                    <Link to='/win'>Win</Link>
                  </li>
                </ul>
              </li>
              {/* <li>
                <NavLink to='/design-directory'>Design Directory</NavLink>
              </li> */}
            </ul>
          </nav>
        </div>
      </DesktopTablet>
    </header>
  )
}
export default connect((state) => ({ articles: state.articles }))(Header)
